<div class="viewport-container py-2">
  <h5 class="font-extrabold text-lg">We value your privacy</h5>
  <div class="flex gap-4 flex-col 3xl:flex-row 3xl:gap-8 justify-between">
    <div class="flex-grow text-slate-700 max-w-3xl">
      <p class="mt-1">
        This website uses essential cookies to ensure it works properly,
        and analytics cookies to understand how you interact with it.
        Analytics cookies will only be set if you accept them.
        <a routerLink="/privacy-policy" class="underline text-primary-700">Privacy Policy</a>
      </p>
    </div>
    <div class="button-container">
      <button class="btn btn-flat essential" mat-ripple
              (click)="acceptEssential()">
        Essential Only
      </button>
      <button class="btn btn-flat all" mat-ripple
              (click)="acceptAll()">
        Accept All
      </button>
    </div>
  </div>

</div>